import { DynamicField, DynamicFiledSelected } from '../models/dynamic-field';
import { VehicleConvoy } from '../models/vehicle.convoy';
import { FleetChecklist, FleetChecklistSummary, FleetStatus } from '../models/fleet-checklist';
import { VehicleValidationStatus } from '../models/vehicle-validation';
import {FLEET_TYPES} from '../constants/fleet-type';

import { FleetChecklistType } from "../models/fleet-checklist";


export class FleetChecklistHelper {

  static toSummary(checklist: FleetChecklist): FleetChecklistSummary {
    return {
      ...checklist,
      vehiclesIds: checklist.vehicles.map(v => v.id.toString()),
    }
  }

  static getFleetType(fleetType: string): string {
    return FLEET_TYPES[String(fleetType)] ?? 'Otro';
  }
  static toInternalFields(
    fields: { [key: string]: DynamicFiledSelected }
  ): { [key: string]: DynamicFiledSelected } {

    const result: { [key: string]: DynamicFiledSelected } = {};

    Object.entries(fields || {}).forEach(([key, field]) => {
      let value = field.value;

      if (field.type === 'time' && typeof value === 'string') {
        const [h, m, s = 0] = value.split(':').map(Number);

        const d = new Date();
        d.setHours(h, m, s, 0);

        if (!isNaN(d.getTime())) {
          value = d;
        }
      }

      result[key] = {
        ...field,
        value
      };
    });

    return result;
  }
  static toOutputFields(
    fields: { [key: string]: DynamicFiledSelected }
  ): { [key: string]: DynamicFiledSelected } {

    const result: { [key: string]: DynamicFiledSelected } = {};

    Object.entries(fields || {}).forEach(([key, field]) => {
      let value = field.value;

      if (field.type === 'time' && value instanceof Date) {
        const h = value.getHours().toString().padStart(2, '0');
        const m = value.getMinutes().toString().padStart(2, '0');
        const s = value.getSeconds().toString().padStart(2, '0');

        value = `${h}:${m}:${s}`;
      }

      result[key] = {
        ...field,
        value
      };
    });

    return result;
  }

  static getFieldsDynamicByType(type: string): DynamicField[] {
    switch (type) {
      case 'interno':
        return [
          {
            id: 'programada',
            name: 'Programada',
            type: 'time',
            order: 2
          },
          {
            id: 'validada',
            name: 'Validada',
            type: 'time',
            order: 3
          }
        ]
      case 'externo':
        return [
          {
            id: 'ruta',
            name: 'RUTA',
            type: 'autocomplete',
            order: 2
          },
          {
            id: 'programada',
            name: 'Programada',
            type: 'time',
            order: 3
          },
          {
            id: 'validada',
            name: 'Validada',
            type: 'time',
            order: 4
          }
        ]
      case FleetChecklistType.DIAZ:
        return [
          {
            id: 'programada',
            name: 'Programada',
            type: 'time',
            order: 1
          },
          {
            id: 'validada',
            name: 'Validada',
            type: 'time',
            order: 2
          },
          {
            id: 'ruta',
            name: 'RUTA',
            type: 'text',
            order: 3
          }
      ]
      case FleetChecklistType.MOVILBUS:
        return [
          {
            id: 'programada',
            name: 'Programada',
            type: 'time',
            order: 1
          },
          {
            id: 'validada',
            name: 'Validada',
            type: 'time',
            order: 2
          },
          {
            id: 'service',
            name: 'Servicio',
            type: 'text',
            order: 3
          }
      ]
      default:
        return [
          // {
          //   id: 'programada',
          //   name: 'Programada',
          //   type: 'time',
          //   order: 1
          // },
          {
            id: 'validada',
            name: 'Validada',
            type: 'time',
            order: 2
          }
        ];
    }
  }
  static getFieldSuggestionsById(id: string): string[] {
    switch (id) {
      case 'ruta':
        return ['AQP-CUS', 'CUS-AQP', 'TYA-AQP', 'AQP-TYA'];
      default:
        return [''];
    }
  }

  static getDefaultConvoyFields(vehicleConvoy: VehicleConvoy): DynamicFiledSelected[] {
    return [
      {
        id: 'ruta',
        value: vehicleConvoy?.ruta || '',
      },
      {
        id: 'programada',
        value: vehicleConvoy?.departureTime || '',
      },
      {
        id: 'validada',
        value: ''
      }
    ]
  }

  static getFleetChecklistMock(): FleetChecklist {
    return {
      id: '1',
      name: 'Checklist Flota Prueba',

      status: 'pending' as FleetStatus,
      type: 'interno',

      createdAt: new Date(),
      updatedAt: new Date(),

      tags: ['GPS', 'CIPIA'],

      fields: [
        {
          id: '1',
          name: 'Hora Inicio',
          type: 'time',
          order: 1
        },
        {
          id: '2',
          name: 'Observación Técnica',
          type: 'text',
          order: 2
        }
      ],

      criteria: [
        {
          id: '1',
          name: 'GPS',
          states: [
            { id: '9', name: 'Activo' },
            { id: '8', name: 'Inactivo' },
            { id: '10', name: 'Observación' }
          ]
        },
        {
          id: '2',
          name: 'CIPIA',
          states: [
            { id: '9', name: 'Activo' },
            { id: '8', name: 'Inactivo' },
            { id: '10', name: 'Observación' }
          ]
        }
      ],

      vehicles: [
        {
          id: 'v1',
          checklist_id: '1',
          unitCode: 'C001',
          umaCode: 'C001',
          plate: 'Z7Y455',
          status: VehicleValidationStatus.completed,

          fields: {
            '1': {
              id: '1',
              type: 'time',
              value: new Date()
            },
            '2': {
              id: '2',
              type: 'text',
              value: 'Sin novedades'
            }
          },

          criteria: {
            '1': {
              id: '1',
              selectedStateId: '9'
            },
            '2': {
              id: '2',
              selectedStateId: '8'
            }
          },

          observations: 'Vehículo operativo',
          modified: false
        },

        {
          id: 'v2',
          checklist_id: '1',
          unitCode: 'C002',
          umaCode: 'C001',
          plate: 'CAH-852',
          status: VehicleValidationStatus.incompleted,
          fields: {
            '1': {
              id: '1',
              type: 'time',
              value: new Date()
            },
            '2': {
              id: '2',
              type: 'text',
              value: ''
            }
          },

          criteria: {
            '1': {
              id: '1',
              selectedStateId: '10'
            },
            '2': {
              id: '2',
              selectedStateId: '9'
            }
          },

          observations: '',
          modified: false
        }
      ]
    };
  }

}
